// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bib_ss","PhotoTitleEditForm__cancelBtn":"iy_b bib_sw bib_sv"};